
export default {
  name: 'ConfigurableBorder',
  values: {
    borderWidth: undefined,
    borderStyle: undefined,
    borderColor: undefined,
    borderRadius: undefined,
    borderImage: undefined,
  },
  meta: {
    extendable: false,
  },
}
